import React from "react";

import { RecommendationCarousel } from "./container/RecommendationCarousel";
import { SearchRecommendationProvider } from "./context/SearchRecommendationContext";

import "./App.css";
import { AnalyticsProviderWithConfig } from "./analytics/AnalyticsProviderWithConfig";

function App() {
  return (
    <AnalyticsProviderWithConfig>
      <SearchRecommendationProvider>
        <RecommendationCarousel />
      </SearchRecommendationProvider>
    </AnalyticsProviderWithConfig>
  );
}

export default App;
